import React from 'react';
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import {panelSpan} from '../state/panelLayout';

/**
 * Envuelve un panel en `useSortable`. El span de la grilla va acá; los listeners del drag van SÓLO
 * al grip (los selects, el toggle del heatmap y la tabla ordenable son interactivos: si el nodo
 * entero fuera el handle, ordenar una columna arrastraría el panel).
 *
 * `dropSide` ('before' | 'after' | null) dibuja la barra que anuncia dónde va a caer el panel que
 * se está arrastrando. La grilla ya no usa estrategia de sorting —con spans de 3, 6 y 12 los
 * transforms la deformaban—, así que esta barra es la única señal del destino (card PlFYrmTo).
 */
export function SortablePanel({panel, disabled = false, dropSide = null, children}) {
    const {attributes, listeners, setNodeRef, transform, transition, isDragging} = useSortable({id: panel.uid, disabled});
    const style = {
        gridColumn: `span ${panelSpan(panel)}`,
        transform: CSS.Transform.toString(transform),
        transition: isDragging ? 'none' : transition,
        opacity: isDragging ? 0.4 : 1,
        minWidth: 0,
    };
    return (
        <div ref={setNodeRef} style={style}
             className={`inf-sortable ${isDragging ? '-dragging' : ''} ${dropSide ? `-drop-${dropSide}` : ''}`}>
            {children(disabled ? null : {...attributes, ...listeners})}
        </div>
    );
}
